import React from "react";
import PropTypes from "prop-types";
import { Pagination, Icon } from "semantic-ui-react";
import { Title } from "../../components";

const Paginate = ({
  length,
  prev,
  active,
  perpage,
  isEnabled,
  seefulllist,
  seeFullListLink,
  ...props
}) => {
  let id = { ...props };
  let perpages = perpage ? perpage : 3;
  let pages = Math.ceil(length / perpages);
  let prevCond = active <= 1;
  let nextCond = active == pages;

  return (
    <div
      style={{ textAlign: "center" }}
      className={
        props.ispage && props.ispage === "nhmap" ? "pagination_main" : ""
      }
    >
      <Pagination
        boundaryRange={0}
        secondary
        activePage={active}
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        totalPages={pages}
        prevItem={
          prevCond
            ? null
            : {
                content: (
                  <Title size="small" color="blue">
                    <Icon name="angle left" />
                  </Title>
                ),
                icon: true,
              }
        }
        nextItem={null}
        pageItem={null}
        onPageChange={(e, value) => prev(e, { value }, id)}
      />
      {!prevCond && !isEnabled && (
        <span style={{ marginLeft: 20 }}>&nbsp;&nbsp;</span>
      )}

      {isEnabled && (
        <>
          {!props.ispage && (
            <span
              className="pagination_see_full_list"
              style={{ marginRight: 50 }}
            >
              <a
                href={seeFullListLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                See Full List
              </a>
            </span>
          )}

          {length !== 0 &&
            props.id == "top" &&
            props.ispage &&
            props.ispage === "nhmap" && (
              <span
                className="seefulllist"
                onClick={seefulllist}
                style={{
                  marginRight: -46,
                  border: "1px solid grey",
                  borderRadius: "5px",
                  padding: "7px 22px 11px 22px",
                  marginTop: 1,
                  userSelect: "none",
                }}
              >
                See Full List
              </span>
            )}
        </>
      )}
      <Pagination
        boundaryRange={0}
        secondary
        activePage={active}
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        totalPages={pages}
        prevItem={null}
        nextItem={
          nextCond
            ? null
            : {
                content: (
                  <Title size="small" color="blue">
                    <Icon name="angle right" />
                  </Title>
                ),
                icon: true,
              }
        }
        pageItem={null}
        onPageChange={(e, value) => prev(e, { value }, id)}
      />
    </div>
  );
};

Paginate.propTypes = {
  length: PropTypes.number.isRequired,
  prev: PropTypes.func,
  active: PropTypes.number,
};

export default Paginate;
